import { type PersonaSize } from '../components/Persona.Props';

interface PersonaSizeStyle {
    rootIsTiny: string;
    rootIsExtraExtraSmall: string;
    rootIsSmall: string;
    rootIsExtraSmall: string;
    rootIsLarge: string;
    rootIsExtraLarge: string;
    rootIs28: string;
    rootIsSmallPlus: string;
    rootIsRegularPlus: string;
}

const getPersonaSizeClass = (styles: PersonaSizeStyle) => ({
    [0]: 'ms-Persona--tiny ' + styles.rootIsTiny,
    [1]: 'ms-Persona--xxs ' + styles.rootIsExtraExtraSmall,
    [2]: 'ms-Persona--xs ' + styles.rootIsExtraSmall,
    [3]: 'ms-Persona--sm ' + styles.rootIsSmall,
    [4]: '',
    [9]: 'ms-Persona--rp ' + styles.rootIsRegularPlus,
    [5]: 'ms-Persona--lg ' + styles.rootIsLarge,
    [6]: 'ms-Persona--xl ' + styles.rootIsExtraLarge,
    [7]: 'ms-Persona--28 ' + styles.rootIs28,
    [8]: 'ms-Persona--smp ' + styles.rootIsSmallPlus,
});

export default getPersonaSizeClass;
